module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.allOptions.length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.allOptions), function(eachOption, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(eachOption.eng))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachOption.swa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachOption.nextStage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachOption.nextApps))]), _vm._v(" "), _c('td', [_c('switch-button', {
      model: {
        value: (eachOption.enabled),
        callback: function($$v) {
          eachOption.enabled = $$v
        },
        expression: "eachOption.enabled"
      }
    })], 1), _vm._v(" "), (!eachOption._id) ? _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.removeOption(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (eachOption._id) ? _c('td', [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.editOption(index)
        }
      }
    })]) : _vm._e()])
  }))]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Option")]), _vm._v(" "), _c('th', [_vm._v("Swahili")]), _vm._v(" "), _c('th', [_vm._v("Next Stage")]), _vm._v(" "), _c('th', [_vm._v("Next Apps")]), _vm._v(" "), _c('th', [_vm._v("Disable/Enable")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-741bbf7b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/allOptions.vue
// module id = pyRM
// module chunks = 1